import { TixTime } from '@/TixTime/TixTime';
/**
 * Frontend cap on how far ahead we show sessions / calendar days. ~3 years
 * (365 + 365 + 366), matching the API's own default window (`calendarDefaultLimit`
 * in tix-api `api/inventory/calendar.go`).
 */
const MAX_HORIZON_DAYS = 1096;
/**
 * Upper bound (exclusive) to use for `start_datetime._lt` when fetching dates or
 * sessions for online display.
 *
 * Rules:
 *   - Single events have at most one date and should always be visible, no
 *     matter how far out they are scheduled. Returns `undefined` to signal that no
 *     `_lt` filter should be applied.
 *   - If `release_sessions_until` is null, fall back to start-of-month + 1 year.
 *   - Otherwise, return the earlier of `release_sessions_until` and
 *     today + {@link MAX_HORIZON_DAYS}.
 */
export function dateTimeHorizon(event) {
    if (event.event_type === 'single') {
        return undefined;
    }
    const tz = event.venue.timezone;
    const now = new TixTime(null, tz);
    if (!event.release_sessions_until) {
        return now.startOfMonthOneYearAhead().format();
    }
    const releaseUntil = new TixTime(event.release_sessions_until, tz);
    // Normalize to start-of-day so the cap is stable for 24h. Without this, the
    // millisecond-precision `now` produces a unique `start_datetime._lt` on every
    // call, busting the CDN / getCached cache key for far-future releases.
    const maxHorizon = now.startOfDay().add(MAX_HORIZON_DAYS, 'days');
    return releaseUntil.isBefore(maxHorizon) ? releaseUntil.format() : maxHorizon.format();
}
